module.exports = __webpack_public_path__ + "static/img/4.1bbdf32.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/4.png
// module id = kQw8
// module chunks = 1